/**
 * Language Switcher Component
 * 語言切換元件 - 支援中英文切換
 */
import { GlobalOutlined } from '@ant-design/icons';
import { Dropdown, Grid } from 'antd';
import type { MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';

const { useBreakpoint } = Grid;

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const handleLanguageChange = (language: string) => {
    i18n.changeLanguage(language);
  };

  const items: MenuProps['items'] = [
    {
      key: 'zh-TW',
      label: '繁體中文',
      onClick: () => handleLanguageChange('zh-TW'),
    },
    {
      key: 'en',
      label: 'English',
      onClick: () => handleLanguageChange('en'),
    },
  ];

  // 取得當前語言顯示文字
  const currentLanguageText = i18n.language === 'zh-TW' ? '繁體中文' : 'English';

  return (
    <Dropdown menu={{ items, selectedKeys: [i18n.language] }} placement="bottomRight">
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          cursor: 'pointer',
          padding: '4px 12px',
          borderRadius: '4px',
          transition: 'background-color 0.3s',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = 'transparent';
        }}
      >
        <GlobalOutlined style={{ fontSize: '16px' }} />
        {/* 手機版不顯示文字，只顯示圖示 */}
        {!isMobile && <span>{currentLanguageText}</span>}
      </div>
    </Dropdown>
  );
};

export default LanguageSwitcher;
